const toNumber = value => {
  const number = Number(value)
  return Number.isFinite(number) ? number : 0
}

const getPaymentSummary = payments => {
  const validPayments = (payments || []).filter(payment => payment.status !== 'canceled')
  const expected = validPayments.reduce(
    (total, payment) => total + toNumber(payment.gross_amount != null ? payment.gross_amount : payment.amount),
    0,
  )
  const paid = validPayments
    .filter(payment => payment.status === 'paid')
    .reduce((total, payment) => total + toNumber(payment.reconciled_amount), 0)
  const percentage = expected > 0 ? (paid / expected) * 100 : 0

  return {
    expected,
    paid,
    percentage,
    progress: Math.min(Math.max(percentage, 0), 100),
  }
}

const installmentValue = installment => {
  const parsed = Number(installment)
  return Number.isFinite(parsed) ? parsed : installment
}

const compareInstallments = (first, second) => {
  const a = installmentValue(first)
  const b = installmentValue(second)
  if (typeof a === 'number' && typeof b === 'number') return a - b
  return String(a).localeCompare(String(b), 'pt-BR', { numeric: true })
}

const buildCommissionMatrix = commissions => {
  const source = commissions || []
  const installments = [...new Set(source.map(item => item.installments))].sort(compareInstallments)
  const rowsByKey = new Map()

  source.forEach(item => {
    const consultant = item.consultant || {}
    const key = `${item.id_consultant_role || 'removed'}:${item.id_consultant || consultant.id || 'unknown'}`
    if (!rowsByKey.has(key)) {
      rowsByKey.set(key, {
        key,
        roleId: item.id_consultant_role,
        roleName: item.role_name || 'Removido',
        consultantId: item.id_consultant || consultant.id,
        consultantName: consultant.name || 'PN não identificado',
        cells: {},
      })
    }
    const existing = rowsByKey.get(key).cells[item.installments]
    const isCurrentInvoiced = item.invoice != null && item.invoice !== ''
    const isExistingInvoiced = existing && existing.invoice != null && existing.invoice !== ''
    if (!existing || (isCurrentInvoiced && !isExistingInvoiced)) {
      rowsByKey.get(key).cells[item.installments] = item
    }
  })

  const rows = [...rowsByKey.values()].sort((first, second) => {
    const roleOrder = String(first.roleName).localeCompare(String(second.roleName), 'pt-BR')
    return roleOrder || String(first.consultantName).localeCompare(String(second.consultantName), 'pt-BR')
  })

  return { installments, rows }
}

module.exports = {
  buildCommissionMatrix,
  compareInstallments,
  getPaymentSummary,
}
